import React from 'react';
import { isRankableLength } from '@shared/leaderboardRanking';

/**
 * "Excluded: invalid length" badge (#165 A3). Shown on the admin lists for a
 * catch whose length isn't rankable (not a finite positive number, or over
 * MAX_CATCH_LENGTH_CM), so it is visible rather than silently dropped from
 * placings, mystery fish and champion points. Text plus icon, not colour
 * alone, per the accessibility rule.
 */
const ExcludedLengthBadge: React.FC<{
  catchItem: { species?: string | null; lengthCm?: number | null };
  className?: string;
}> = ({ catchItem, className = '' }) => {
  if (isRankableLength(catchItem.lengthCm)) return null;
  return (
    <span
      data-testid="excluded-length-badge"
      title="This length is not a valid number, or is over the maximum for ranking. It is excluded from placings, mystery fish and champion points."
      className={`inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-900 ${className}`}
    >
      ⚠ Excluded: invalid length
    </span>
  );
};

export default ExcludedLengthBadge;
